import io from 'socket.io-client';

export default class AdiaLive5SignallingClient{
    constructor(options) {
    	this.enableLogging = options.enableLogging;

    	this.server = '';
    	let path = '';
    	if(options.url){
    		const urlParts = options.url.split('/');

    		if(urlParts.length >= 3){
				this.server = (urlParts.splice(0,3)).join('/');
				path = urlParts.join('/');
			}
		}

    	if(!this.server){
    		console.error('Invalid server URL');
		}

		this.socketOptions = {
			forceNew: false,
			reconnection: false,
		}

    	if(path){
			this.socketOptions.path = '/' + path + '/socket.io';
		}

        //this.socket = io(url, {secure: true});

        this.onSignalling = null;
        this.onRoomNotification = null;
        this.onDisconnect = null;
    }

    register(token){
    	const _this = this;

    	if(this.enableLogging){
			console.log('%c' + 'Registering with token:', 'color:slategray; font-weight:bold', token);
		}

        return new Promise(function (resolve, reject) {
			if(_this.enableLogging){
				console.log('%c' + 'Opening connection to:', 'color:slategray; font-weight:bold', _this.server, _this.socketOptions);
			}

			_this.socket = io(_this.server, _this.socketOptions);

            _this.socket.on('connect', function(){
				if(_this.enableLogging){
					console.log('%c' + 'Connected, registering...', 'color:slategray; font-weight:bold');
				}

                _this.socket.emit('register', token);
            });

			_this.socket.on('connect_error', function(error){
				if(_this.enableLogging){
					console.log('%c' + 'Connect error:', 'color:slategray; font-weight:bold', error);
				}

				if(error.message.includes('xhr poll error')){
					//_this.socket.close(true);
					reject('Server unreachable');
				}
			});

			_this.socket.on('disconnect', function(reason){
				if(_this.enableLogging){
					console.log('%c' + 'Disconnected:', 'color:slategray; font-weight:bold', reason);
				}

				_this.onDisconnect(reason);
			});

            _this.socket.on('signalling', function(signallingMsg){
                _this.onSignalling(signallingMsg);
            });

			_this.socket.on('participantsList', function(participantsList){
				_this.onParticipantsListReceived(participantsList);
			});

			_this.socket.on('roomNotification', function(roomNotification){
				_this.onRoomNotification(roomNotification);
			});

            _this.socket.on('registered', function(registrationInfo){
                resolve(registrationInfo.channels);
            });

			_this.socket.on('registrationFailed', function(){
				if(_this.enableLogging){
					console.log('%c' + 'Registration failed', 'color:slategray; font-weight:bold');
				}

				reject('Registration Failed');
			});
        })
    }

    getParticipantsList(onParticipantsListReceived){
        this.onParticipantsListReceived = onParticipantsListReceived;

        this.socket.emit('getParticipantsList');
    }

    send(data){
        this.socket.emit('signalling', data);
    }

    sendRoomNotification(data){
		this.socket.emit('roomNotification', data);
	}

    unregister(){
        this.socket.close();
    }
}